import React  , { useRef ,  useState , useEffect  , useCallback , forwardRef , useContext  } from 'react'; 
import Layout from 'js/components/page-components/Layout.js'; 
import Page from 'js/components/page-components/Page.js';
import { useTranslate } from 'js/components/helpers/Translate.js';
import translationDb   from 'js/Pages/Translations/OrdersPage/translations.js';
import AppContext from  'js/Contexts/App.js'; 
import 'scss/pages/AppInitPage.scss';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CircularProgress from '@mui/material/CircularProgress';

import usePageMetaTitle from 'js/components/helpers/HtmlMeta/usePageMetaTitle.js';


import Paper from '@mui/material/Paper';

const AppInitPage = () => {


    return (
             
            <Page className="PG_AppInitPage">
                    <div className="contentHolder">
                        <img  src="/img/logos/ordercollab-favicon_64x64.png" /><br />
                        <CircularProgress size="20px" />
                    </div>
            </Page>

    );
};


class AppInitPageLoader {
    constructor( location , onUpdate  , startupData  ){
        this.orderData = null;
        this.startupData = startupData ;
        this.location = location;
        this.onUpdate = onUpdate;
        this.jsModule = null;
        this.errorLoading = false;
    
        this.triggerUpdateAlert = this.triggerUpdateAlert.bind(this);
        this.isFullyLoaded = this.isFullyLoaded.bind(this);
        this.canBeShown = this.canBeShown.bind(this);
        this.getRenderComponent = this.getRenderComponent.bind(this);
        this.canHandleRequest = this.canHandleRequest.bind(this);
        this.handleRequest = this.handleRequest.bind(this);
        this.setOnUpdate = this.setOnUpdate.bind(this);
        this.loadJsModule = this.loadJsModule.bind(this);

        this.jsModule = AppInitPage;
    }

    canHandleRequest(location){
        return false;
    }

    handleRequest(location){
        this.location = location;
        this.onUpdate();
    }

    setOnUpdate( onUpdate ) {
        this.onUpdate = onUpdate;
    }

    async loadJsModule() {
            this.jsModule = NotFoundPage;
            this.triggerUpdateAlert();
        
    }

    triggerUpdateAlert(){
        if( this.onUpdate ){
            this.onUpdate();
        }
    }
    isFullyLoaded(){
        return (  !this.errorLoading  && this.jsModule );
    }

    canBeShown(){
        if( this.errorLoading || !this.jsModule){
            return false;
        }
        return true;
    }
    getRenderComponent(){
       
        return <this.jsModule startupData={this.startupData}   /> ;
    }


}

export default AppInitPage;
export { AppInitPageLoader } ;